import { render, staticRenderFns } from "./agent-chat.vue?vue&type=template&id=29ff88a1&scoped=true"
import script from "./agent-chat.vue?vue&type=script&lang=js"
export * from "./agent-chat.vue?vue&type=script&lang=js"
import style0 from "./agent-chat.vue?vue&type=style&index=0&id=29ff88a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff88a1",
  null
  
)

export default component.exports